/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function PhoneIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="phone"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M20.23 4.087A13.431 13.431 315 0 1 4.087 20.23" data-tinysvg-shape="arc" data-tinysvg-arc="7.154 7.154 13.431 13.431 31.804 148.196 315 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.23 4.088L18.288 3.588C17.094 3.282 15.888 4.039 15.646 5.248C15.434 6.31 16.046 7.364 17.074 7.707L20.175 8.741" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M4.088 20.23L3.588 18.288C3.282 17.094 4.039 15.888 5.248 15.646C6.31 15.434 7.364 16.046 7.707 17.074L8.741 20.175" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
